import { Box, Modal } from '@mui/material';
import { useUserData } from 'hooks/use-user-data';
import React, { useEffect } from 'react';
import useCustomerOnboardingStore from 'stores/customer-onboarding-store';
import { makeStyles } from 'tss-react/mui';
import FirstSteps from './first-steps';
import StartYourJourney from './start-your-journey';

interface Props {
  hasLinkedinAccounts?: boolean;

  handleOpenAddLinkedinAccountDialog?(isStarterExperience: boolean): () => void;
}

const CustomerOnboarding: React.FC<Props> = ({ hasLinkedinAccounts, handleOpenAddLinkedinAccountDialog }) => {
  const { classes } = useStyles();
  const { onboardingDone } = useUserData();
  const { open, handleOpenCustomerOnboardingDialog, handleCloseCustomerOnboardingDialog, onboardingStep, setOnboardingStep } =
    useCustomerOnboardingStore((state) => ({
      open: state.open,
      handleOpenCustomerOnboardingDialog: state.handleOpenCustomerOnboardingDialog,
      handleCloseCustomerOnboardingDialog: state.handleCloseCustomerOnboardingDialog,
      onboardingStep: state.onboardingStep,
    setOnboardingStep: state.setOnboardingStep,
  }));

  const productSelectionStep = 0;
  const firstInstructionsStep = productSelectionStep + 1;

  const handleIncreaseOnboardingStep = () => {
    setOnboardingStep(Math.min(onboardingStep + 1, firstInstructionsStep));
  };

  useEffect(() => {
    // Open onboarding dialog for users who haven't completed onboarding
    if (!onboardingDone) {
      handleOpenCustomerOnboardingDialog(onboardingDone);
    }
  }, [onboardingDone]);

  return (
    <Modal className={classes.modal} open={open} disableEnforceFocus={true} disableAutoFocus={true}>
      <Box className={classes.onboarding}>
        {onboardingStep === productSelectionStep ? (
          <StartYourJourney handleNextStep={handleIncreaseOnboardingStep} handleCloseModal={handleCloseCustomerOnboardingDialog} />
        ) : onboardingStep === firstInstructionsStep ? (
          <FirstSteps
            hasLinkedinAccounts={hasLinkedinAccounts}
            handleOpenAddLinkedinAccountDialog={handleOpenAddLinkedinAccountDialog}
            handleCloseModal={handleCloseCustomerOnboardingDialog}
          />
        ) : null}
      </Box>
    </Modal>
  );
};

const useStyles = makeStyles()((theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  onboarding: {
    position: 'relative',
    padding: '48px',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:focus-visible': {
      outline: 'none',
    },
    [theme.breakpoints.down('md')]: {
      padding: '8px',
    },
  },
}));

export default CustomerOnboarding;
